/* Your Favourite Corner — Shopify theme behaviour
   Ported from the static site. The cart now talks to Shopify's real cart
   instead of localStorage, so checkout, payments, and inventory all work. */
(function () {
  'use strict';

  var routes = (window.YFC && window.YFC.routes) || {};
  var moneyFormat = (window.YFC && window.YFC.moneyFormat) || '₹{{amount}}';

  /* --------------------------------------------------------------- money */
  function formatMoney(cents) {
    var value = (cents / 100);
    var str = value.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var noDecimals = value.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, str)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, str)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  /* --------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  /* ----------------------------------------------------------- cart count */
  function paintCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
      nodes[i].hidden = count === 0;
    }
  }

  function refreshCartCount() {
    fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); })
      .catch(function () { /* non-fatal */ });
  }

  /* ------------------------------------------------------------ add to bag */
  function addToCart(formData, successName) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) { throw new Error(data.description || data.message || 'Could not add to bag'); }
          return data;
        });
      })
      .then(function (item) {
        toast((successName || item.product_title || 'Item') + ' added to bag');
        refreshCartCount();
        return item;
      })
      .catch(function (err) {
        toast(err.message || 'Sorry, that could not be added.');
      });
  }

  // Quick-add buttons on product cards
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quickadd-form]');
    if (!form) return;
    e.preventDefault();
    var card = form.closest('.card-wrap');
    var name = card ? card.dataset.name : null;
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; }
    addToCart(new FormData(form), name).then(function () {
      if (btn) { btn.disabled = false; }
    });
  });

  // Main add-to-bag on the product page
  var pdpForm = document.getElementById('product-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pdpForm.querySelector('[data-add-to-cart]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      addToCart(new FormData(pdpForm)).then(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to bag'; }
      });
    });
  }

  /* --------------------------------------------------------- variant picker */
  var variantDataEl = document.querySelector('[data-variant-data]');
  if (variantDataEl && pdpForm) {
    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }

    var selectors = pdpForm.querySelectorAll('[data-option-selector]');
    var variantIdInput = pdpForm.querySelector('[data-variant-id]');
    var priceDisplay = document.querySelector('[data-price-display]');
    var submitBtn = pdpForm.querySelector('[data-add-to-cart]');
    var mainImage = document.querySelector('[data-main-image]');

    function currentOptions() {
      return Array.prototype.map.call(selectors, function (s) { return s.value; });
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function onOptionChange() {
      var v = matchVariant(currentOptions());
      if (!v) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;

      if (priceDisplay) {
        var html = formatMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s>' + formatMoney(v.compare_at_price) + '</s>';
        }
        priceDisplay.innerHTML = html;
      }

      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      }

      if (mainImage && v.featured_image && v.featured_image.src) {
        mainImage.src = v.featured_image.src;
      }

      // keep the URL shareable
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }

    for (var s = 0; s < selectors.length; s++) {
      selectors[s].addEventListener('change', onOptionChange);
    }
  }

  /* ------------------------------------------------------------- quantity */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (!step) return;
    var input = document.querySelector('[data-qty-input]');
    if (!input) return;
    var next = (Number(input.value) || 1) + Number(step.dataset.step);
    input.value = Math.max(1, next);
  });

  /* ---------------------------------------------------------------- header */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ------------------------------------------------------------ accordions */
  var triggers = document.querySelectorAll('.acc-trigger, .cs-layer');
  for (var t = 0; t < triggers.length; t++) {
    triggers[t].addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!open));
      var panel = this.classList.contains('cs-layer')
        ? this.querySelector('.cs-detail')
        : document.getElementById(this.getAttribute('aria-controls'));
      if (panel && panel.classList.contains('acc-panel')) {
        panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
      }
    });
  }

  /* ------------------------------------------------- collection sort/filter */
  // Sorting is handled by Shopify server-side so it works across every page
  // of results, not just the products currently rendered.
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------- pdp gallery */
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImg = document.querySelector('[data-main-image]');
  for (var th = 0; th < thumbs.length; th++) {
    thumbs[th].addEventListener('click', function () {
      if (!mainImg) return;
              mainImg.srcset = this.dataset.thumb;
        mainImg.src = this.dataset.thumb;
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].setAttribute('aria-current', String(thumbs[k] === this));
      }
    });
  }

  /* ------------------------------------------------------------- cart page */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    function changeLine(index, quantity) {
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: index, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { toast('Could not update your bag.'); });
    }

    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-index]');
      if (rm) {
        e.preventDefault();
        changeLine(Number(rm.dataset.removeIndex), 0);
        return;
      }

      var st = e.target.closest('[data-line-step]');
      if (st) {
        e.preventDefault();
        var idx = Number(st.dataset.index);
        var input = cartRoot.querySelector('[data-line-qty][data-index="' + idx + '"]');
        if (!input) return;
        var next = Math.max(0, (Number(input.value) || 1) + Number(st.dataset.lineStep));
        changeLine(idx, next);
      }
    });

    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      changeLine(Number(input.dataset.index), Math.max(0, Number(input.value) || 0));
    });
  }

  /* -------------------------------------------------------------- reveals */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var r = 0; r < reveals.length; r++) { io.observe(reveals[r]); }
  } else {
    for (var r2 = 0; r2 < reveals.length; r2++) { reveals[r2].classList.add('is-in'); }
  }
})();

/* ============================================================ v2 additions */
(function () {
  'use strict';

  /* Product carousels ---------------------------------------------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var section = root.closest('section') || document;
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '20') || 20;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* Reveal on scroll for v2 elements ------------------------------------- */
  var items = document.querySelectorAll('.v2-reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      // stagger siblings so grids cascade rather than snapping in together
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(siblings, 6) * 70 + 'ms';
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

  items.forEach(function (el) { io.observe(el); });
})();
